const initialState = {
    isHyperLinkInitialState:false
};
const decryptDatareducers = (state=initialState,action) => {

    switch(action?.type){
        case 'DECRYPT_DATA_REDUCERS_HYPERLINK':
        return {
            ...state,
            ...action?.payload
        }

        case 'ISHYPERLINK_DATA':        
        return {
            isHyperLinkInitialState:action?.payload
        }

        case 'CLEAR_DECRYPTDATA_HYPERLINK':
            return initialState
    default:
      return state;
    }
}

export default decryptDatareducers;